import { CalenderIcon } from '@/components/icon/Calender';
import { DATE_YMD_HMS, ORDER_STATUS_CMS, STEP } from '@/configs/constants';
import { formatDateTime } from '@/utils/datetime';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { Suspense, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import StepProgress from './components/step-progress';
import { useStore } from '@/hooks/useStore';
import { ConfirmationStep, InformationUpdateStep } from './components/step';
import { useParams } from 'react-router-dom';

export default observer(function ReservationEditPage() {
    // hook
    const { t } = useTranslation();
    const { id } = useParams();

    // store
    const { reservationStore: { reservation, getReservationCMSDetail } } = useStore();
    // state
    const [step, setStep] = useState<number>(STEP.STEP_1);
    const [completeStep, setCompleteStep] = useState<number>(STEP.STEP_1);
    // lifecycle
    useEffect(() => {
        if (id) {
            getReservationCMSDetail({ id });
        }
    }, [id]);

    // function
    const nextStep = () => {
        setStep(step => step < STEP.STEP_2 ? (step + 1) : STEP.STEP_2);
        setCompleteStep(step => step < STEP.STEP_2 ? (step + 1) : STEP.STEP_2);
    };

    const back = () => {
        setStep(step => step === STEP.STEP_1 ? step : step - 1);
    };

    return (
        <Suspense fallback={<div>{t('words_title.loading')}</div>}>
            <div className=''>
                <div className='flex flex-col gap-4 relative'>
                    <div className='flex flex-col text-fs-mid18 leading-lh-sma14 -top-[52px] absolute gap-2'>
                        <div className='flex gap-1 items-center'>
                            <label className='font-semibold'>
                                {t('field.reservation.reservation_code')}
                                :
                                {' '}
                            </label>
                            <span className='font-medium'>{reservation?.information?.orderCodeSystem}</span>
                            {reservation?.information?.orderStatus != null ?
                                (
                                    <div className={classNames(`${ORDER_STATUS_CMS[reservation?.information?.orderStatus]?.color} ${ORDER_STATUS_CMS[reservation?.information?.orderStatus]?.bgColor} border ${ORDER_STATUS_CMS[reservation?.information?.orderStatus]?.border} ml-1 font-normal px-3 h-6 flex items-center text-[1rem] rounded-[0.25rem]`, 'font-medium')}>
                                        {t(`${ORDER_STATUS_CMS[reservation?.information?.orderStatus]?.key}`)}
                                    </div>
                                ) :
                                <p>--</p>}
                        </div>
                        <div className='flex gap-1 items-center'>
                            <label className=''>
                                <CalenderIcon />
                            </label>
                            <span className='text-black-1 font-normal'>{reservation?.information?.orderDate && formatDateTime(reservation?.information?.orderDate, DATE_YMD_HMS)}</span>
                        </div>
                    </div>
                    <div>
                        <div className='pb-2 sm:px-10'>
                            <StepProgress currentStep={step} />
                        </div>
                        <>
                            {
                                step === STEP.STEP_1 ?
                                    <InformationUpdateStep next={nextStep} completeStep={completeStep} /> :
                                    step === STEP.STEP_2 ? <ConfirmationStep back={back} completeStep={completeStep} /> : <></>
                            }
                        </>
                    </div>
                </div>
            </div>
        </Suspense>
    );
});
